import React, {useEffect, useRef} from 'react';

import styles from './styles/input-expand.module.css';

export default function InputExpand({ type, label, maxLength, placeholder, name, value, displayValue, error, handleChange }) {
    const textareaRef = useRef(null);

    const countText = displayValue !== undefined ? displayValue : value; // 글자수 계산용 텍스트

    const currentLength = countText ? countText.length : 0;

    const resizeHeight = () => {
        if (textareaRef.current) {
            textareaRef.current.style.height = 'auto'; // 초기화
            textareaRef.current.style.height = textareaRef.current.scrollHeight + 'px';
            textareaRef.current.style.lineHeight = '100%';
        }
    };

    useEffect(() => {
        resizeHeight();
    }, [value]);

    return (
        <div className={styles.wrapper} datatype={type}>
            <p className={styles.label}>{label}</p>
            <p className={styles.length}>{currentLength}/{maxLength}</p>
            <textarea ref={textareaRef}
                      datatype={type}
                      datatype-2={error ? 'error' : ''}
                      placeholder={placeholder}
                      name={name}
                      value={value}
                      onChange={handleChange}
                      onInput={resizeHeight}
                      autoComplete='off'
                      rows={1}
            />
        </div>
    );
}
